/**
 * Posts a detached form and lets the browser navigate the result.
 *
 * Every way out of this drawer ends in the legacy stack — `cart?xCmd=checkout`,
 * `apply-lbdeal`, `skip-lbdeal` — and each of those answers with a redirect chain that
 * finishes on `checkout.php`. A form post lets the browser follow that chain as an
 * ordinary navigation. A fetch would follow it invisibly, hand back checkout's html, and
 * leave us to navigate to `response.url` anyway, having fetched the page twice.
 *
 * It is also what the legacy cart does, down to the field names: `xPaymentPayload` for a
 * wallet's authorization and one `xLBIDs[]` per cart line being upgraded.
 *
 * An array value repeats the field, which is how PHP is told it is a list — a single
 * `xLBIDs[]` with a comma in it arrives as one string, and the deal would be applied to
 * nothing.
 */
export default function submitForm(action: string, fields: Record<string, string | string[]>): void {
  const form = document.createElement('form');

  form.method = 'POST';
  form.action = action;

  Object.entries(fields).forEach(([name, value]) => {
    (Array.isArray(value) ? value : [value]).forEach((one) => {
      const field = document.createElement('input');

      field.type = 'hidden';
      field.name = name;
      field.value = one;

      form.appendChild(field);
    });
  });

  document.body.appendChild(form);
  form.submit();
}
